













import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import Query from '../../../components/query/index.vue'
import myTable from '../../../components/table/my-table.vue'
@Component({
  components:{Query,myTable}
})
export default class extends AbpBase{
    columns:any = []
    list = []
    totalCount = 0
    params = {
        loading:false,
        pageSize:10,
        page:1,
        queryParaIdArr:[],
        queryTypeId:null
    }
    search(data:any){
        console.log(data)
        this.params.page = 1;
        this.params.queryParaIdArr = data.map((item:any)=>{
            let value = item.defaultValue;
            if(item.defaultValue){
                value = item.dataType==7?item.defaultValue.join(','):item.dataType==10?item.defaultValue.join('$'):item.defaultValue
            }
            return {
                key:item.id,
                value:value
            }
        })
        this.getData()
    }
    async load(data:any,query:any){
        this.params.queryParaIdArr = query.map((item:any)=>{
            return {
                key:item.id,
                value:item.defaultValue
            }
        })
        //生成表列
        this.columns = []
        data[0].queryResultDto.forEach((item,index) => {
            this.columns.push(
                {
                    title:item.columnComment,
                    key:'k'+index
                }
            )
        });
        console.log(this.columns)
        this.params.queryTypeId = data[0].id
        this.getData()
        
    }
    async getData(){
        let res = await this.PageData(this.params)
        let data = res.data
        this.totalCount = data.count;
        this.list = data.resultData.map((item:any,index:any)=>{
            let row = {};
            item.forEach((v:any,i:any)=>{
                row['k'+i] = item[i]
            })
            return row;
        })
    }
    pageChange(page:number){
        this.params.page = page
        this.getData();
    }
    pagesizeChange(pagesize:number){
        this.params.pageSize = pagesize
        this.getData();
    }
}
